import { Language } from "../i18n/translations";

export interface LanguageOption {
  code: Language;
  name: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: "en" as Language, name: "English", flag: "🇺🇸" },
  { code: "vi" as Language, name: "Tiếng Việt", flag: "🇻🇳" },
];

export const DEFAULT_LANGUAGE: Language = "en";

export const LANGUAGE_STORAGE_KEY = "taroto-language";
